import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, mergeMap, Observable, of, switchMap } from 'rxjs';
import { Action } from '@ngrx/store';
import { ProfileHttpService } from '../../http/profile/profile-http.service';
import {
  AdvancePreferencesActions,
  AdvancePreferencesAPIActions,
} from '../actions/advance-preferences.actions';

@Injectable()
export class AdvancePreferencesEffects {
  public loadAdvancePreferences$: Observable<Action> = createEffect(() =>
    this._actions$.pipe(
      ofType(
        AdvancePreferencesActions.loadAdvancePreferences,
        AdvancePreferencesActions.refreshAdvancePreferences,
      ),
      switchMap(() =>
        this._profileHttpService.advancePreferences$.pipe(
          mergeMap((advancePreferences) =>
            of(
              AdvancePreferencesAPIActions.loadedAdvancePreferencesSuccessfully(
                {
                  advancePreferences,
                },
              ),
            ),
          ),
          catchError((error) =>
            of(
              AdvancePreferencesAPIActions.loadedAdvancePreferencesUnsuccessfully(
                {
                  error,
                },
              ),
            ),
          ),
        ),
      ),
    ),
  );

  constructor(
    private _actions$: Actions,
    private _profileHttpService: ProfileHttpService,
  ) {}
}
